import { createAction } from 'redux-actions';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import { actionKey } from './constants';
export const setPageSafety = createAction(`${actionKey}.ADS_SET_PAGE_SAFETY`, ({ safety })=>({
        safety
    }));
export const recordDeviationSafety = createAction(`${actionKey}.ADS_DEV_SAFETY`, ({ deviation, safety })=>({
        deviationId: getDeviationEntityId(deviation),
        safety
    }));
export const queueSafetyChangeForDeviation = createAction(`${actionKey}.QUEUE_DEV_SAFETY`, ({ deviation })=>({
        deviationId: getDeviationEntityId(deviation)
    }));
export const newPageLoaded = createAction(`${actionKey}.ADS_NEW_PAGELOADED`, ()=>({}));
export const logLastAdRefresh = createAction(`${actionKey}.LOG_LAST_AD_REFRESH`, (time)=>({
        time
    }));
export const setSafetyState = createAction(`${actionKey}.SET_SAFETY_STATE`, (safeState)=>({
        safeState
    }));
